module.exports = __webpack_public_path__ + "img/03-8.502ec8fc.png";